var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLjArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.351,
    height: 17.056,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 858",
    d: "M.882 0a.882.882 0 01.882.882v10a1.176 1.176 0 001.176 1.176h6.4l-1.729-1.729a.882.882 0 111.248-1.248l3.235 3.235a.882.882 0 010 1.248L8.858 16.8a.882.882 0 11-1.248-1.248l1.729-1.729h-6.4a2.941 2.941 0 01-2.938-2.942v-10A.882.882 0 01.882 0z",
    fill: "#5300f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLjArrow);
export default __webpack_public_path__ + "static/media/lj-arrow.5d121b4d61bc3fd8d919b03aafd40c1e.svg";
export { ForwardRef as ReactComponent };